import { render, staticRenderFns } from "./checkup-cadence.vue?vue&type=template&id=0ef252b2&"
import script from "./checkup-cadence.vue?vue&type=script&lang=js&"
export * from "./checkup-cadence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports